import { Link } from 'react-router-dom';
import { Calendar, Clock, User } from 'lucide-react';

export default function BlogCard({ post, featured = false }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  if (featured) {
    return (
      <Link
        to={`/blog/${post.slug}`}
        className="block group"
        data-testid={`blog-card-${post.slug}`}
      >
        <article className="bg-white border border-gray-100 hover:border-[hsl(var(--gold))]/50 hover:shadow-xl transition-all duration-300 overflow-hidden h-full flex flex-col">
          <div className="relative overflow-hidden aspect-[16/9]">
            <img
              src={post.featured_image}
              alt={post.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            <span className="absolute top-4 left-4 bg-secondary text-white px-3 py-1 text-xs font-bold uppercase tracking-[0.1em]">
              {post.category}
            </span>
          </div>
          <div className="p-6 flex-1 flex flex-col">
            <h2 className="text-xl lg:text-2xl font-playfair font-bold text-primary group-hover:text-[hsl(var(--gold))] transition-colors mb-3 line-clamp-2 leading-tight">
              {post.title}
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3 flex-1">
              {post.excerpt}
            </p>
            <div className="flex items-center gap-4 text-xs text-gray-500 pt-4 border-t border-gray-100">
              <span className="flex items-center gap-1.5">
                <User size={14} className="text-secondary" />
                {post.author_name}
              </span>
              <span className="flex items-center gap-1.5">
                <Calendar size={14} className="text-secondary" />
                {formatDate(post.published_date)}
              </span>
              <span className="flex items-center gap-1.5">
                <Clock size={14} className="text-secondary" />
                {post.read_time} min
              </span>
            </div>
          </div>
        </article>
      </Link>
    );
  }

  return (
    <Link
      to={`/blog/${post.slug}`}
      className="block group"
      data-testid={`blog-card-${post.slug}`}
    >
      <article className="bg-white border border-gray-100 hover:border-[hsl(var(--gold))]/50 hover:shadow-xl transition-all duration-300 overflow-hidden h-full flex flex-col">
        <div className="relative overflow-hidden aspect-[16/10]">
          <img
            src={post.featured_image}
            alt={post.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <span className="absolute top-3 left-3 bg-secondary text-white px-2.5 py-1 text-xs font-bold uppercase tracking-[0.1em]">
            {post.category}
          </span>
        </div>
        <div className="p-5 flex-1 flex flex-col">
          <h3 className="text-lg font-playfair font-bold text-primary group-hover:text-[hsl(var(--gold))] transition-colors mb-2 line-clamp-2 leading-snug">
            {post.title}
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-2 flex-1">
            {post.excerpt}
          </p>
          <div className="flex items-center gap-3 text-xs text-gray-500 pt-3 border-t border-gray-100">
            <span className="flex items-center gap-1">
              <Calendar size={12} className="text-secondary" />
              {formatDate(post.published_date)}
            </span>
            <span className="flex items-center gap-1">
              <Clock size={12} className="text-secondary" />
              {post.read_time} min
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
}
